var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _rect3, _path8, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#ffffff;}.cls-3{fill:#00a1d3;}.cls-4{fill:#d12200;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 41,
    rx: 2.5,
    width: 28.707,
    x: 4.5,
    y: 4.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 39,
    rx: 1.5,
    width: 26.707,
    x: 5.5,
    y: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.854,16.467a3.3,3.3,0,1,0-3.3-3.3A3.308,3.308,0,0,0,18.854,16.467Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.854,10.86a2.3,2.3,0,1,1-2.3,2.3A2.306,2.306,0,0,1,18.854,10.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.076,27.063h3.555a2.855,2.855,0,0,0,2.852-2.852V21.933a4.63,4.63,0,1,0-9.259,0v2.278A2.855,2.855,0,0,0,17.076,27.063Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.224,21.933a3.63,3.63,0,1,1,7.259,0v2.278a1.854,1.854,0,0,1-1.852,1.852H17.076a1.854,1.854,0,0,1-1.852-1.852Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.851,37.239H10.856a.5.5,0,0,0,0,1h16a.5.5,0,1,0,0-1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.851,31.692H10.856a.5.5,0,0,0,0,1h16a.5.5,0,0,0,0-1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.792,8.22a3.711,3.711,0,0,0-3.707,3.707V31.912a.511.511,0,0,0,.034.182l2.86,7.344a.987.987,0,0,0,.313.469V41.28a.5.5,0,0,0,1,0V39.91a.929.929,0,0,0,.3-.444l2.87-7.372a.516.516,0,0,0,.034-.183V11.927A3.711,3.711,0,0,0,41.792,8.22Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "43.192 35.18 40.394 35.18 39.213 32.146 44.372 32.146 43.192 35.18"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 16.596,
    width: 5.415,
    x: 39.085,
    y: 14.551
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.792,9.22A2.711,2.711,0,0,1,44.5,11.927v1.624H39.085V11.927A2.711,2.711,0,0,1,41.792,9.22Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.793 38.773 40.783 36.18 42.802 36.18 41.793 38.773"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.f3c4e88e0927f166e515d1be60b58137.svg";
export { ForwardRef as ReactComponent };